export default {
  fi: {
    ResetPasswordScene: {
      changePassword: 'Vaihda salasana',
    },
  },
};
